import CmYuvaHero from '../components/cmyuva/CmYuvaHero';
import Navbar  from '../components/common/Navbar';
import CmYuvaAbout from '../components/cmyuva/CmYuvaAbout';
import CmYuvaBenefits from '../components/cmyuva/CmYuvaBenefits';
import CmYuvaServices from '../components/cmyuva/CmYuvaServices.jsx';
import CmYuvaCTA from '../components/cmyuva/CmYuvaCTA';
import CmYuvaDocumentsRequired from '../components/cmyuva/CmYuvaDocumentsRequired';
import CmYuvaForm from '../components/cmyuvaForm/CmYuvaForm.jsx';
import { useEffect, useState } from 'react';
import CmYuvaNews from '../components/cmyuva/CmYuvaNews.jsx';



const CmYuvaScheme = () => {
  const [formActive, setFormActive] = useState(false)
  useEffect(() => {
  if (formActive) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = "";
  };
}, [formActive]);


  return (
    <div className="cmyuva_scheme_page">
        {formActive && <CmYuvaForm setFormActive={setFormActive}/>}
        <Navbar />
        <CmYuvaHero setFormActive={setFormActive}/>
        <CmYuvaAbout/>
        <CmYuvaServices/>
        <CmYuvaBenefits/>
        <CmYuvaDocumentsRequired/>
        {/* <CmYuvaNews /> */}
        {/* <CmYuvaProgram/> */}
        <CmYuvaCTA setFormActive={setFormActive}/>

    </div>
  )
}

export default CmYuvaScheme;